module.exports = __webpack_public_path__ + "img/notepad.652cc656.png";